import { UTILITY_IDS } from '~/utils/constants';

export const ALLOWED_UTILITIES = [
  UTILITY_IDS['PSE&G NJ'],
  UTILITY_IDS['Atlantic City Electric'],
  UTILITY_IDS['Jersey Central Power & Light'],
  UTILITY_IDS['PEPCO MD'],
  UTILITY_IDS['Baltimore Gas & Electric'],
];
